import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { useTranslate } from '@tolgee/react'

interface CatalogueDialogMessageProps {
  name: string
  quantity?: number
}

export const CatalogueDialogMessage = ({ name, quantity }: CatalogueDialogMessageProps) => {
  const { t } = useTranslate()

  if (!quantity) {
    return (
      <Typography variant='body1'>
        {t('deleteEmptyCatalogueMessage', 'This catalogue is empty and ready to be deleted.')}
      </Typography>
    )
  }

  const quantityText =
    quantity > 1
      ? t('items', '{quantity} items', { quantity })
      : t('item', '{quantity} item', { quantity })

  return (
    <Stack spacing={2}>
      <Typography variant='body1'>
        {t(
          'deleteNonEmptyCatalogueMessage',
          'Deleting the catalogue will remove all related information.',
        )}
      </Typography>
      <Typography variant='body1'>
        {t(
          'deleteNonEmptyCatalogueMessageDetails',
          'It will remove the “{name}” catalogue with {quantity} related to it. All of them will be deleted and can’t be used anymore in the future. The orders that were created before won’t be changed.',
          { name, quantity: quantityText },
        )}
      </Typography>
    </Stack>
  )
}
